module.exports = __webpack_public_path__ + "media/images/lighthouse-8c01f5f615c13997800ce0869489443e.png";